import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { getLocationImage, getLocationDrawImages, getPlaceDrawImages } from 'tripPlanner/api'
import { LocationDrawImagesRequest } from 'tripPlanner/api/types'
import * as LocationImageKeys from '../reactQueryKeys/locationImage'

export type ActivityLocationImage = {
  id: string
  name: string
  placeId: string
  imageIds: Array<string>
}

export const useLocationImage = (
  placeId: string | undefined,
): UseQueryResult<Array<ActivityLocationImage>> => {
  return useQuery({
    queryKey: LocationImageKeys.locationImage(placeId || ''),
    queryFn: () => getLocationImage(placeId || ''),
    enabled: !!placeId,
  })
}

export type LocationDrawImagesData = LocationDrawImagesRequest | undefined
export type DrawImagesCategory = 'locations' | 'places'

export const useLocationDrawImages = (
  locationData: LocationDrawImagesData,
  category: DrawImagesCategory = 'locations',
): UseQueryResult<Array<string>> => {
  return useQuery({
    queryKey: LocationImageKeys.locationDrawImages(
      category,
      locationData?.title ?? '',
      locationData?.description,
      locationData?.emoji,
      locationData?.searchHelper,
    ),
    queryFn: async() => {
      if (!locationData) return []
      const requestData: LocationDrawImagesRequest = {
        title: locationData.title,
        description: locationData.description,
        emoji: locationData.emoji,
        searchHelper: locationData.searchHelper,
      }
      if (category === 'places') {
        const result = await getPlaceDrawImages(requestData)
        return result.imageUrls ?? []
      }
      if (category === 'locations') {
        const result = await getLocationDrawImages(requestData)
        return result.imageIds ?? result.imageUrls ?? []
      }
      return []
    },
    enabled: !!locationData,
  })
}
